import { Container, Box } from '@mui/material';
import LoadingIndicator from 'components/LoadingIndicator';
import { FC } from 'react';
import { IsMobile } from 'utils/global';
import DocumentTable from '../Table/DocumentTable';
import { DocumentInfo } from 'api/documents';
import PlaceholderEmptyList from 'components/PlaceholderEmptyList';

interface DocumentContainerProps {
  documents: DocumentInfo[] | undefined;
  isLoading: boolean;
  isError: boolean;
  commercialRelation: string;
}
const DocumentContainer: FC<DocumentContainerProps> = ({
  documents,
  isLoading,
  isError,
  commercialRelation,
}) => {
  const isMobile = IsMobile();

  if (isLoading) {
    return <LoadingIndicator data-testid="client-loading" />;
  }

  if (!isLoading && (documents === undefined || documents.length < 1 || isError)) {
    return <PlaceholderEmptyList />;
  }

  return (
    <Container>
      <Box mx={isMobile ? 3 : 6} my={5}>
        <DocumentTable documents={documents!} commercialRelation={commercialRelation} />
      </Box>
    </Container>
  );
};

export default DocumentContainer;
